import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const CartContainer = lazy(() => import('@!/Store/Cart/containers/CartContainer'))

const CartApp = (props) => {
  return (
    <AppProvider>
      <Suspense fallback={null}>
        <CartContainer {...props} />
      </Suspense>
    </AppProvider>
  )
}

export default CartApp
